import axios from 'axios';
import { canAccessFeature } from '@/utils/access';

const ICONS = {
  overview: 'chart-line',
  scorecard: 'user-check',
  attribution: 'users',
  coding: 'file-medical',
  quality: 'clipboard-list-check',
  utilization: 'hospital',
  explorer: 'magnifying-glass',
  patients: 'user',
};

export const PATIENTS_TAB = 'patients';

export async function fetchPortalTabs(entityId = null) {
  const params = entityId ? { entity: entityId } : {};
  const { data } = await axios.get('/api/impact_analytics/agent-pages/external/', { params });
  return data.tabs || [];
}

export function portalNavItems(tabs) {
  const items = tabs
    .filter((tab) => tab.key !== PATIENTS_TAB)
    .map((tab) => ({ id: tab.key, label: tab.label, icon: ICONS[tab.key] || 'file-lines' }));
  if (canAccessFeature('ext_tab_patient') || canAccessFeature('ext_tab_overview')) {
    items.push({ id: PATIENTS_TAB, label: 'Patients', icon: ICONS[PATIENTS_TAB] });
  }
  return items;
}
